(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/lb-ui/scroll-aware-top-overlay/assets/javascripts/scroll-aware-top-overlay.js') >= 0) return;  svs.modules.push('/components/lb-ui/scroll-aware-top-overlay/assets/javascripts/scroll-aware-top-overlay.js');
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }

const _React = React,
  useState = _React.useState,
  useEffect = _React.useEffect,
  useRef = _React.useRef;
const _ref = _,
  throttle = _ref.throttle;
const TopOverlayWrapper = svs.components.lbUi.scrollAwareTopOverlay.TopOverlayWrapper;
const ScrollAwareTopOverlay = _ref2 => {
  let children = _ref2.children,
    containerElementSelector = _ref2.containerElementSelector,
    intersectionElementSelector = _ref2.intersectionElementSelector,
    _ref2$intersectionThr = _ref2.intersectionThreshold,
    intersectionThreshold = _ref2$intersectionThr === void 0 ? 0.5 : _ref2$intersectionThr,
    onTopOverlayWrapperClick = _ref2.onTopOverlayWrapperClick,
    showTopOverlay = _ref2.showTopOverlay;
  const _useState = useState(true),
    _useState2 = _slicedToArray(_useState, 2),
    isIntersectionElementVisible = _useState2[0],
    setIsIntersectionElementVisible = _useState2[1];
  const _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isScrollingUp = _useState4[0],
    setIsScrollingUp = _useState4[1];
  const _useState5 = useState(null),
    _useState6 = _slicedToArray(_useState5, 2),
    containerTopOffset = _useState6[0],
    setContainerTopOffset = _useState6[1];
  const lastScrollTop = useRef(0);
  useEffect(() => {
    const intersectionElement = intersectionElementSelector ? document.querySelector(intersectionElementSelector) : null;
    const containerElement = containerElementSelector ? document.querySelector(containerElementSelector) : null;
    const handleScroll = throttle(() => {
      const scrollTop = containerElement ? containerElement.scrollTop : window.scrollY || document.documentElement.scrollTop;
      setIsScrollingUp(scrollTop < lastScrollTop.current);
      lastScrollTop.current = scrollTop <= 0 ? 0 : scrollTop;
    }, 200);
    const observer = new IntersectionObserver(_ref3 => {
      let _ref4 = _slicedToArray(_ref3, 1),
        entry = _ref4[0];
      setIsIntersectionElementVisible(entry.isIntersecting);
    }, {
      root: containerElement,
      threshold: [intersectionThreshold]
    });
    if (intersectionElement) {
      observer.observe(intersectionElement);
    }
    if (containerElement) {
      const containerElementRect = containerElement.getBoundingClientRect();
      setContainerTopOffset(containerElementRect.top);
      containerElement.addEventListener('scroll', handleScroll, {
        passive: true
      });
    } else {
      window.addEventListener('scroll', handleScroll, {
        passive: true
      });
    }
    return () => {
      if (intersectionElement) {
        observer.unobserve(intersectionElement);
      }
      if (containerElement) {
        containerElement.removeEventListener('scroll', handleScroll);
      } else {
        window.removeEventListener('scroll', handleScroll);
      }
    };
  }, [containerElementSelector, intersectionElementSelector, intersectionThreshold]);
  return React.createElement(TopOverlayWrapper, {
    containerTopOffset: containerTopOffset,
    isVisible: !isIntersectionElementVisible && (isScrollingUp || showTopOverlay),
    onClick: onTopOverlayWrapperClick
  }, children);
};
setGlobal('svs.components.lbUi.scrollAwareTopOverlay.ScrollAwareTopOverlay', ScrollAwareTopOverlay);

 })(window);